export function isEmpty(obj: unknown): obj is null | undefined {
  return obj === undefined || obj === null;
}
